export default "/images/Inks_Graphic_Arts.webp?7b5e35e9af6f2d1bb91db227145103bc";